import { Props } from "./Models";
import HeaderView from "./view";

const Header = (props: Props) => {
  return <HeaderView {...props} />;
};

export default Header;
